<template>
  <div class="container">
    <dingbu @cart-tatus="cartTatus"></dingbu>
    <div class="home_content">
      <div
        class="bg_color"
        :style="{
          background:
            'url(' +
            require('../../assets/img/' + bei_ing) +
            ') no-repeat center center',
          'background-size': '100% 100%',
        }"
      >
        <div class="w">
          <div class="inform__box">
            <div class="box__top">
              <span class="shou__ye">首页</span>
              <span>
                <img class="img__o" src="../../assets/xiangyou (2).png" alt />
              </span>
              <span class="ton__zhi">通知公告</span>
            </div>
          </div>
        </div>
        <div class="box-content">
          <router-link
            tag="div"
            class="content-listu"
            v-for="(item, index) in addki"
            :key="index"
            :to="{ path: '/information', query: { id: item.id } }"
          >
            <div class="list-one">
              <div class="titles">{{ item.title }}</div>
              <div class="tim">{{ item.createtime }}</div>
            </div>
            <div class="to">{{ item.desc }}</div>
          </router-link>
          <div class="fenye">
            <el-pagination
              background
              layout="prev, pager, next, jumper"
              :total="total"
              :page-size="pageNum"
              @prev-click="prev"
              @next-click="next"
              @current-change="current"
            ></el-pagination>
          </div>
        </div>
        <dibu></dibu>
      </div>
      <daohan></daohan>
    </div>
  </div>
</template>

<script>
import daohan from "../daohan";
import dibu from "../dibu";
import dingbu from "../dingbu";
export default {
  components: {
    daohan,
    dibu,
    dingbu
  },
  data() {
    return {
      addki: [],
      page: 1,
      pageNum: 10,
      total: 0,
      type: '',
      keyword: "",
      bei_ing: this.Public.bei_ing,
    };
  },
  created() {
    console.log(this.$route.query);
    if (this.$route.query.info && JSON.parse(this.$route.query.info)) {
      let obj = this.$route.query.info && JSON.parse(this.$route.query.info)
      this.total = obj.total_num
      this.addki = obj.info
      console.log(obj);
    }
    if (this.total == 0) {
      this.getindex()
    }
  },
  mounted() {
    let keyword = this.$route.query.keyword;
    this.keyword = keyword
  },
  methods: {
    cartTatus(val) {
      this.addki = val.info
      this.total = val.total_num
    },
    //分页
    //上一页
    prev() {
      console.log("eee")
      this.page = this.page - 1
      this.getindex()
    },
    //下一页
    next() {
      console.log("eee")
      this.page = this.page + 1
      this.getindex()
    },
    //当前页
    current(e) {
      console.log(e)
      this.page = e
      this.getindex()
    },
    //通知公告接口
    getindex() {
      let that = this, url = "lists/index", param = {
        keyword: this.keyword == undefined ? "" : this.keyword,
        page: this.page,
        pageNum: this.pageNum
      };
      this.post(url, param, "通知公告")
        .then((res) => {
          this.addki = res.data.info;
          this.total = res.data.total_num
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
<style>
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #2d52b1 !important;
  color: #fff;
  border-radius: 50%;
}
.el-pagination.is-background .el-pager li {
  margin: 0 5px;
  background-color: #ffffff;
  color: #06121e;
  min-width: 30px;
  border-radius: 2px;
}
</style>
<style scoped lang="less">
@import "../../css/inform.css";
.container {
  margin-top: 213px;
  width: 100%;
  height: 100%;
  background-color: #fff;

  .home_content {
    width: 100%;
    height: 100%;
    box-sizing: border-box;

    .bg_color {
      width: 100%;
      height: 448px;
      box-sizing: border-box;

      .inform__box {
        width: 100%;

        .box__top {
          width: 100%;
          padding: 20px 0px;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          .shou__ye {
            font-size: 14px;
            color: #fff;
            color: #d1d0d0;
          }

          .img__o {
            width: 7px;
            height: 12px;
            margin-left: 11px;
          }

          .ton__zhi {
            font-size: 14px;
            color: #8c9198;
            margin-left: 12px;
          }
        }
      }
    }
  }
}
</style>